<template>
  <v-content>
    <v-card width="400" class="mx-auto mt-5">
      <v-card-title>
        <h1 class="display-1">Login</h1>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email"
            required
            type="email"
            prepend-icon="mdi-account-circle"
          />
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            label="Password"
            required
            :type="showPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn to="/register">Register</v-btn>
        <v-btn
          color="info"
          text
          :disabled="!isEmailValid"
          @click.stop="forgotPassword = true"
        >
          Forgot Password
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="info" @click="login" :loading="loading">Login</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="forgotPassword" max-width="290">
      <v-card>
        <v-card-title class="headline">Forgot Password</v-card-title>
        <v-card-text>Send new password to {{ this.email }}?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="forgotPassword = false">No</v-btn>
          <v-btn color="primary" @click="forgotPasswordClick">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
import { dataService, errorMessageMixin } from "../shared";

export default {
  name: "Login",
  mixins: [errorMessageMixin],
  created() {
    // reset login status
    this.logout();
    console.log("Env is: ", process.env.VUE_APP_ENV);
    console.log("msg parameter", this.$route.query.msg);
  },
  props: {},
  data: () => ({
    showPassword: false,
    valid: true,
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    password: "",
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length >= 8) || "Password must be at least 8 characters"
    ],
    loading: false,
    forgotPassword: false
  }),
  computed: {
    isEmailValid() {
      return this.email && /.+@.+\..+/.test(this.email);
    }
  },
  methods: {
    async login() {
      this.$store.state.snackbar = false;
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const model = {
            email: this.email,
            password: this.password
          };
          await this.$store.dispatch("login", model);
          this.$router.push("/");
        }
        catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        this.loading = false;
      }
    },
    logout() {
      this.$store.dispatch("logout").then(() => {});
    },
    forgotPasswordClick() {
      this.$store.state.snackbar = false;
      this.forgotPassword = false;

      dataService.forgotPassword({
        email: this.email
      });
      this.$store.state.error = "Please check your email for your new password.";
      this.$store.state.snackbar = true;
    }
  }
};
</script>
